import { Api } from "@lcms/api-definition";
import { getEndpoint } from "./get-endpoint";

export const configurationsRouter = Api.getRouter()
    .use(getEndpoint.inNamespace('configurations').toDefinition())